import './inventory-dashboard.scss';
import { InventoryGantt } from './inventory-gantt/inventory-gantt';

export const InventoryDashboard = () => {
  return (
    <div className="inventory-dashboard">
      <InventoryGantt isDashboard={true} />
    </div>
  );
};
